import {
  PlusCircleOutlined,
  ApartmentOutlined,
  SettingOutlined,
  HomeOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from './AppConfig';

const dashBoardNavTree = [
  {
    key: 'dashboards',
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: 'sidenav.dashboard',
    icon: ApartmentOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: 'dashboards-home',
        path: `${APP_PREFIX_PATH}`,
        title: 'sidenav.dashboard.home',
        icon: HomeOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'dashboards-create-event',
        path: `${APP_PREFIX_PATH}/evento/nuevo`,
        title: 'sidenav.dashboard.events.create',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'dashboards-events',
        path: `${APP_PREFIX_PATH}`,
        title: 'sidenav.dashboard.events',
        icon: ApartmentOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'dashboards-transactions',
        path: `${APP_PREFIX_PATH}/transactions`,
        title: 'sidenav.dashboard.transactions',
        icon: DollarCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'dashboards-configuration',
        path: `${APP_PREFIX_PATH}/profile/edit`,
        title: 'sidenav.dashboard.configuration',
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
